/** @jsx jsx */
import React, { useState } from "react";
import { css, jsx } from "@emotion/react";
import nodataIcon from "../../../images/search-nodata.svg";
import bg1 from "../../../ng-components/Page/noissue101-background-top.svg";
import bg2 from "../../../ng-components/Page/noissue101-background-bottom.svg";
import WrapCardCommon from "../wrap/WrapCardCommon";
import recommendImage from "../../../images/inspo-recommends.gif";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";

const SearchSection = ({ filters, data, showPosts = 9, filterHandler }) => {
    return (
        <>
            <style jsx>
                {`
                    .search-page-body {
                    }
                `}
            </style>
            <section>
                <ResponsiveMasonry
                    className="masonry-wrapper"
                    columnsCountBreakPoints={{ 350: 1, 700: 2, 900: 3 }}
                >
                    {/* <div ref={this.loaderRef}>
                        <i class="fa fa-spinner fa-pulse fa-3x fa-fw" style={{color:'#2C1847'}}></i>
                        <span class="sr-only">Loading...</span>
                    </div> */}
                    <Masonry>
                        {data &&
                            data.slice(0, showPosts).map((post, index) => {
                                if (index === 1) {
                                    return <SearchWrapCard key={'sw'+index} />;
                                } else if (index === 13) {
                                    return <CardRecommended key={'cr'+index} />;
                                } else {
                                    return (
                                        <WrapCardCommon
                                            key={'wcc1'+index}
                                            post={post.node}
                                            id={'wcc'+ index}
                                            isSearchCard={true}
                                        />
                                    );
                                }
                            })}
                    </Masonry>
                </ResponsiveMasonry>

                {!data && <NoData filters={filters} filterHandler={filterHandler}/>}
            </section>
        </>
    );
};

export default SearchSection;

export const NoData = ({ filters, filterHandler }) => {
    const tags = ["Packaging", "Paper", "Box", "Fabrics", "Compostable"];
    return (
        <>
            <style jsx>
                {`
                    .search-page-body {
                    }
                    .nodata {
                        background-image: url(${nodataIcon});
                        background-repeat: no-repeat;
                        background-position: bottom center;
                        height: 65rem;
                        width: 100%;
                        background-color: white;
                        padding: 4rem;
                    }
                    .tags {
                        width: 100%;
                        margin: 1.4rem 0;
                    }
                    .tag-link {
                        border-radius: 2rem;
                        border: unset;
                        margin: 0.5rem;
                        color: #616161;
                        background: #ededed;
                        font-size: 1rem;
                        line-height: 2.4em;
                        padding: 0.5rem 1.5rem;
                        cursor: pointer;
                        font-family: Soleil, -apple-system, BlinkMacSystemFont,
                            Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell,
                            Fira Sans, Droid Sans, Helvetica Neue, sans-serif;
                        letter-spacing: 0;
                        text-align: center;
                        display: inline-block;
                    }
                `}
            </style>

            <div className="nodata">
                <h3
                    css={css`
                        margin: 2rem 0;
                        font-size: 2rem;
                        line-height: 2rem;
                        color: #000000;
                    `}
                >
                    No results for
                </h3>
                <h2
                    css={css`
                        margin: 2rem 0;
                        font-size: 3rem;
                        line-height: 3rem;
                        color: #000000;
                    `}
                >{`"${filters?.query}"`}</h2>
                <p
                    css={css`
                        font-size: 1.6rem;
                        line-height: 1.6rem;
                        margin: 2rem 0;
                        color: #000000;
                    `}
                >
                    Don’t worry! Why not try one of these?
                </p>
                <div>
                    <div className="tags">
                        {tags.map((tag, index) => (
                            <span className="tag-link" key={index} onClick={()=>filterHandler(tag)}>
                                {tag}
                            </span>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};

export function CardRecommended() {
    return (
        <div
            css={css`
                max-width: 36rem;
                border-radius: 2rem;
                margin: auto;
                margin-top: 5rem;
                @media (min-width: 699px) and (max-width: 1439px){
                    padding: 0 1.2rem;
                }
            `}
        >
            <a href="/noissue-recommends/">
                <img
                    src={recommendImage}
                    alt="Inspo Recommends"
                    css={css`
                        border-radius: 2rem;
                    `}
                />
            </a>
        </div>
    );
}

export function SearchWrapCard() {
    return (
        <>
            <style jsx>
                {`
                    .featured-card-item-1 {
                        margin: auto;
                        margin-top: 6rem;
                        max-width: 36rem;
                        height: 36rem;
                        background-image: url(${bg1}), url(${bg2});
                        background-position: top left, bottom left;
                        background-size: contain;
                        background-repeat: no-repeat;
                        border-radius: 1rem;
                        background-color: #f8dea1;
                        display: flex;
                        flex-direction: column;
                    }

                    .text {
                        margin: auto;
                    }
                    h2 {
                        margin: 1rem;
                        font-size: 3rem;
                        font-weight: $font-bold;
                        color: $color-purple;
                    }
                    span {
                        color: $color-pink5;
                    }
                    @media (max-width: $mq-mobile) {
                        .featured-card-item-1 {
                            max-height: 22.5rem;
                            line-height: 1.4rem;
                        }
                        .text {
                            font-size: 1rem;
                        }
                        h2 {
                            margin: 0.2rem;
                            font-size: 1.5rem;
                        }
                        span {
                            font-size: 1.3rem;
                        }
                    }
                `}
            </style>
            <div
                css={css`
                @media (min-width: 699px) and (max-width: 1439px){
                        padding: 0 1.2rem;
                    }
                `}
            >
                <div className="masonry-item  featured-card-item-1">
                    <div className="text">
                        <h2>Search The Wrap</h2>
                        <span></span>
                    </div>
                </div>
            </div>
        </>
    );
}
